import Aos from "../components/aos";
import renderCounter from "../actions/renderCounter";

const PageCounter = ($) => {
	if ($("body").hasClass("page-template-counter")) {
		const pageHeading = $("h1");

		// If there's a trademark span, remove it temporarily
		const $trademark = pageHeading.find(".trademark");
		const hasTrademark = $trademark.length > 0;
		if (hasTrademark) {
			$trademark.remove();
		}

		// Split the text (excluding the trademark)
		const fullText = pageHeading.text().trim();
		const words = fullText.split(" ");

		// Extract the last word
		const lastWord = words.pop();

		// Rebuild the <h1> with the last word wrapped in a span
		pageHeading.html(
			`${words.join(" ")} <span class="last-word">${lastWord}</span>`
		);

		// Re-insert the trademark if it existed. 
		if (hasTrademark) {
			pageHeading.find(".last-word").append($trademark);
		}

		// Any other initialization
		Aos();
		renderCounter($);
	}
};

export default PageCounter;
